module.exports = [{"code":1,"name":"精确车牌布控"},{"code":2,"name":"模糊车牌布控"},{"code":3,"name":"批量车牌布控"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/dispositionType.json
// module id = YA6C
// module chunks = 11